import _ from 'lodash'

export const getAppState = (state) => _.get(state, 'app.state', null)
export const getCsrfToken = (state) => _.get(state, 'app.csrfToken', null)
